import React from "react";

export default props => (
  <g
    id={props.id ? props.id : null}
    className="logo"
    fillRule="evenodd"
    transform={props.transform ? props.transform : null}
    stroke="black"
    strokeWidth=".1"
  >
    <use href="/logo.svg#content"/>
  </g>
);



// WEBPACK FOOTER //
// ./src/components/Logo.js